
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3(65|7|85)|10)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
